import React from 'react';

import { ReactComponent } from './line-pressure.svg';

export default function FarmbotLinePressureIcon() {
  return <ReactComponent width={18} />;
}
